import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

// Icons
import BankIcon from '@material-ui/icons/Payment';
import AddOffersIcon from '@material-ui/icons/CardGiftcard';
import SaveIcon from '@material-ui/icons/Save';

import Alert from '../utility/Alert';

//App Classes
import CardDiv from '../utility/CardDiv';


import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import EmployeeIcon from '@material-ui/icons/SupervisorAccount';

import DirectionsIcon from '@material-ui/icons/Directions';
// import StudentTable from './StudentTable';


import store from '../../store_actions/StudentStore';
import { GetStudents } from '../../store_actions/StudentActions';


function TabContainer(props) {
	return (
		<Typography component="div" style={{ padding: 8 * 3 }}>
			{props.children}
		</Typography>
	);
}

TabContainer.propTypes = {
	children: PropTypes.node.isRequired
};

const styles = (theme) => ({
	root: {
		display: 'flex',
		flexGrow: 1,
		width: '100%'
	},
	searchBar:{
		padding: '2px 4px',
		alignItems: 'center',
		width: 400,
	},
	bar: {
		backgroundColor: '#1a237e'
	},
	rightIcon: {
		marginLeft: theme.spacing.unit
	},
	btnRightA: {
		position: 'absolute',
		top: theme.spacing.unit * 13,
		right: theme.spacing.unit * 10
	},
	btnRightB: {
		position: 'absolute',
		bottom: theme.spacing.unit * 12,
		left: theme.spacing.unit * 13
	},
	searchView: {
		height: 100,
		backgroundColor: 'red',
		width: 400,
	},
	input: {
		marginLeft: 8,
		flex: 1,
	  },
	  iconButton: {
		padding: 10,
	  },
	  divider: {
		width: 1,
		height: 28,
		margin: 4,
	  },
});

class PaymentManager extends Component {
	constructor(props) {
		super(props);
		this.makeChanges = this.makeChanges.bind(this);
		this.state = {
			value : 0,
			students: undefined,
		};
	}
	

	componentWillMount() {
		store.on('change', this.makeChanges);
		GetStudents();

	}

	makeChanges(){
		this.setState({
			students: store.getAllStudents()
		});
	}



	handleChange = (event, value) => {
		this.setState({ value });
	};

 
	onTapSaveChanges = () => {
		this.setState({
			showAlert: true,
			msg: 'All changes will be update on Application API Instantly.',
			title: 'Changes Confirmation!'
		});
	};

	onTapRegister() {
		this.setState({ isAddNew: true });
	}

	onTapBack = () => {
		this.setState({ isAddNew: false, isEdit: false, isViewLocation: false });
	}

	onTapViewLocation = (emp) => {
		this.setState({ isViewLocation : true});
	}

	onEditEmp = (emp) => {
		this.setState({
			current_emp: emp,
			isEdit: true,
			isAddNew: true
		})
	}

	onDeleteEmp(emp) {
		const { id } = emp;
		this.setState({
			id: id,
			showAlert: true,
			msg: 'Are you sure to delete the selected Student?',
			title: 'Delete Confirmation!'
		});
	}

	onExecuteDeleteCommand() {
		const { id } = this.state;
 	}

	onTapSearch = () => {
		this.setState({isSearch: true});
	}

	onTapAdd = () => {

		this.setState({
			isAddNew: true
		});

	}

	onDisplaySearchView = () => {

		return (
			<div style={styles.searchView}>
					<IconButton className={styles.iconButton} aria-label="Menu">
						<MenuIcon />
					</IconButton>
					<InputBase
						className={styles.input}
						placeholder="Search Employee"
						inputProps={{ 'aria-label': 'Search Employee' }}
					/>
					<IconButton className={styles.iconButton} aria-label="Search">
						<SearchIcon />
					</IconButton>
					<Divider className={styles.divider} />
			</div>
		);
	}

	render() {

		const { classes,employees, attendance } = this.props;

		const { value, isAddNew, showAlert, title, msg , students } = this.state;

                return (
                    <div>
                        <Alert
                            open={showAlert}
                            onCancel={this.onDismiss.bind(this)}
                            onOkay={this.onOkay.bind(this)}
                            title={title}
                            msg={msg}
                        />
    
                        <CardDiv title={'Payments'} isAdd={false} onTapAdd={this.onTapAdd.bind(this)}>
                             
                            <Tabs
                                value={value}
                                onChange={this.handleChange}
                                scrollable
                                scrollButtons="on"
                                indicatorColor="secondary"
                                textColor="secondary"
                            >
                                <Tab label="Upload Questions" icon={<EmployeeIcon />} />							
                                <Tab label="Upload Images" icon={<EmployeeIcon />} />
    
                            </Tabs>
    
                            {value === 0 && (
                                <TabContainer>
                                    {/* <div>								
                                    {students !== undefined && (<StudentTable
                                        onEditEmp={this.onEditEmp.bind(this)}
                                        onDeleteEmp={this.onDeleteEmp.bind(this)}
                                        data={students}
                                    />) }
                                    
                                    </div> */}
                                </TabContainer>
                            )}
    
                            {value === 1 && (
                                <TabContainer>
                                    {/* {attendance !== undefined && <StudentTable
                                        data={attendance}
                                        onTapViewLocation = {this.onTapViewLocation.bind(this)}
                                    /> } */}
                                    
                                </TabContainer>
                            )}
                             
    
                        </CardDiv>
                    </div>
                );
		
	}

	//ALERT
	onDismiss = () => {
		this.setState({ showAlert: false });
	};

	onOkay = () => {
		this.setState({ showAlert: false });
		this.onExecuteDeleteCommand();
	};
	
}

PaymentManager.propTypes = {
	classes: PropTypes.object.isRequired
};

export default withStyles(styles)(PaymentManager);
